import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { GcpWifAccesses } from "./accesses.ts";
import { GcpWifComponents } from "./components.ts";

const GcpWifFilters = {} as const satisfies AnyFilterSchema;
export type GcpWifFilters = typeof GcpWifFilters;

export const GcpWifRegistration = Registration({
  accesses: GcpWifAccesses,
  category: "resource",
  components: GcpWifComponents,
  docs: { install: "gcp-wif" },
  filters: GcpWifFilters,
  itemKind: "identity provider",
  label: "GCP Workload Identity Federation",
  logoUrl: "https://www.gstatic.com/cloud/images/navigation/icons.svg#cloudiam",
  maturity: "preview",
  requestType: "bridge",
  useMapping: [
    { use: "iam_write", component: "identity" },
    { use: "identity", component: "identity" },
  ],
});

registerIntegration("gcp-wif", GcpWifRegistration);
